import { StaticImage } from "gatsby-plugin-image"

import { blogUrl } from "../../services/blogLinks"
// Assuming these imports are still needed for the component structure
import LinkedInIcon from "../../images/case-study/ugc/linkedin.svg"
import icon1 from "../../images/svg/1.svg"
import icon2 from "../../images/svg/2.svg"
import icon3 from "../../images/svg/3.svg"
import icon4 from "../../images/svg/4.svg"
import { info } from "console"
import { title } from "process"
import { ImagePositions } from "./CaseStudy"

const laqshyaData = {
  color: "#e5eecc",
  heroTitle: `How Laqshya scaled a premium check-in experience with 800+ AI avatar badges`,
  heroImage: (
    <StaticImage
      src="../../images/case-study/laqshya/hero.png"
      alt="gitex-global-dubai-tech-conference-photo-ai-hero"
    />
  ),
  metrics: {
    title: "Background",
    content: `Every event marketer knows that first impressions matter. For an event marketing agency like <b><a href="https://laqshyaliveex.com/">Laqshya Live Experiences</a></b>, ensuring that first moment felt premium was essential for the <a href='https://www.adityabirla.com/en/'>Aditya Birla Group</a>. Instead of standard photo-based ID cards, Laqshya introduced <b>AI-generated avatar badges created using Premagic</b>. Nearly <b>877 avatar badges were generated for all attendees and printed as high-quality physical badges</b>, giving every guest a distinctive, polished identity the moment they arrived.`,
  },
  images: [
    {
      //   img: (
      //     <StaticImage
      //       src="../../images/case-study/gitex-global-2025/banner.png"
      //       alt="gitex-global-dubai-tech-conference-photo-ai-primary-banner"
      //     />
      //   ),
    },
  ],
  //   gallery: (
  //     <StaticImage
  //       src="../../images/case-study/gitex-global-2025/gallery.png"
  //       alt="gitex-global-dubai-tech-conference-photo-ai-gallery"
  //     />
  //   ),
  caseStudyData: [
    {
      title: "The Challenge",
      subheading: `Rethinking the "standard" attendee identity`,
      info1: `There are many ways to get attendees talking about an event — from large-scale activations to immersive installations. But sometimes, it’s the smallest details that leave the strongest impression. <b>Laqshya Live Experiences</b>, an event marketing agency that has delivered 500+ events for over 100 large enterprise clients, understands this well.`,
      info2: `For the <b>Aditya Birla Capital Day</b>, the Laqshya team chose to rethink one detail most events treat as an afterthought: attendee badges. `,
    },
    {
      title: "The Idea",
      subheading:
        "Make attendee badges feel premium, without adding complexity",
      info1: `The brief was simple. Instead of plain, done-to-death name tags, attendees would receive completely unique, pre-made badges featuring their avatars upon arrival.<br/><br/>Having already worked with Premagic across multiple events, they saw an opportunity to elevate the check-in experience by experimenting with <b>AI-generated avatars</b>. Instead of standard photo-based badges, they introduced Premagic’s avatar badges as a more polished, distinctive alternative — one that felt premium without adding operational complexity.`,

      //   image: (
      //     <StaticImage
      //       src="../../images/case-study/gitex-global-2025/one-platform.png"
      //       alt="gitex-global-dubai-tech-conference-photo-ai-secondary-banner"
      //     />
      //   ),
      inlineLink: {
        text: "Premagic’s AI Avatar Studio",
        link: "https://premagic.com/avatar-studio/",
        tag: "Learn more",
      },
    },

    {
      title: `The Process`,
      subheading: " How it worked behind the scenes",
      info1: `<p>
    To make this work at scale, the entire badge creation workflow was planned well before the event.
  </p>
        <br/>
  <ul style='list-style-type:disc; padding-left:28px;margin:0 0 20px 0;display:flex;flex-direction:column;gap:16px;'>

    <li>
      Attendee data and images were collected during registration.
    </li>

    <li>
      A branded badge template was designed.
    </li>

    <li>
      AI avatars were pre-generated automatically for the entire attendee list using Premagic.
    </li>
    <li>
      High-quality badges were printed in advance and ready before event day.
    </li>

  </ul>

  <p>
    This approach helped avoid two common event-day challenges: the need for on-the-spot, high-quality batch printing that often leads to technical issues, and delays caused by last-minute registrations. As expected, spot registrations were handled separately, while the majority of attendees moved smoothly through check-in.
  </p>`,
      image: (
        <StaticImage
          src="../../images/case-study/laqshya/process.png"
          alt="The process: How it worked behind the scenes"
        />
      ),
      imagePosition: "top",
      inlineLink: {
        text: "Personalized AI Avatars for Event Engagement",
        link: blogUrl("avatarStudio"),
        tag: "Related Read",
      },
    },
    {
      image: (
        <StaticImage
          src="../../images/case-study/laqshya/id-cards.png"
          alt="The process: How it worked behind the scenes"
        />
      ),
      imagePosition: "top",
    },

    {
      title: `The Outcome`,
      subheading: "Small change, big reaction",
      image: (
        <StaticImage
          src="../../images/case-study/laqshya/outcome.png"
          alt="The outcome: Small change, big reaction"
        />
      ),
      imagePosition: "top",
      info1: `The response from attendees was immediate.<br/><br/>The avatar style used was a simple yet vibrant 2D illustration format. Attendees loved seeing themselves represented as avatars on their badges. The badges were such a hit that several attendees asked if they could generate additional avatars, even after the event had ended. That demand wasn’t planned for, and that’s exactly why it mattered.<br/><br/>For Laqshya, this activation proved that avatars could work beyond social media or booth engagement. Even in a fully offline setting, they added personality, polish, and memorability to the event experience.`,
    },
    {
      info1: `For event teams looking to stand out, this case shows that you don’t always need a massive activation to make an impact. Sometimes, rethinking a small but visible touchpoint can completely change how attendees experience your event. If you’re exploring new ways to create memorable, high-quality engagement, we’d love to help you experiment, test, and bring ideas to life at your next event.`,
      image: (
        <StaticImage
          src="../../images/case-study/laqshya/team.png"
          alt="The outcome: Small change, big reaction"
        />
      ),
      imagePosition: "top",
    },
  ],
  // successMetrics: {
  //   title: "Key Success Metrics",
  //   description:
  //     "The platform effectively mobilized the <b>172,566 participants</b> to become active promoters of the event.",
  //   gridValues: [
  //     { id: 1, label: "Poster Shares", value: "16,198" },
  //     { id: 2, label: "Referrals Generated", value: "47,876" },
  //     { id: 3, label: "Ad Spend Saved", value: "$212,262" },
  //     { id: 4, label: "Photo Views", value: "160,531" },
  //     { id: 5, label: "Photo Downloads", value: "2,218" },
  //     { id: 6, label: "Share Rate Increase", value: "94.2%" },
  //     { id: 7, label: "AI Avatars Created", value: "246" },
  //     { id: 8, label: "Ticket Sales Impact", value: "19,907" },
  //   ],
  // },
  isCTAActive: true,
}

export default laqshyaData
